"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusModel = void 0;
/**
 * Holds the header and nodes of the model. The nodes also hold the load state of themselves.
 */
class NexusModel {
    constructor(url, header, nodes) {
        this.url = url;
        this.header = header;
        this._nodes = nodes;
    }
    get nodes() {
        return this._nodes;
    }
    get vertex() {
        return this.header.signature.vertex;
    }
    get face() {
        return this.header.signature.face;
    }
    get sphere() {
        return this.header.sphere;
    }
    get renderMode() {
        return this.face.index ? ["FILL", "POINT"] : ["POINT"];
    }
    get mode() {
        return this.renderMode[0];
    }
    get compressed() {
        var _a;
        return (((_a = this.header) === null || _a === void 0 ? void 0 : _a.signature.flags) || 0) & 2;
    }
    get vertexSize() {
        var _a;
        return ((_a = this.header) === null || _a === void 0 ? void 0 : _a.signature.vertex.size) || 0;
    }
    get faceSize() {
        var _a;
        return ((_a = this.header) === null || _a === void 0 ? void 0 : _a.signature.face.size) || 0;
    }
    getNodeRange(nodeIndex) {
        const node = this._nodes[nodeIndex];
        const next = this._nodes[nodeIndex + 1];
        return { start: node === null || node === void 0 ? void 0 : node.offset, end: next === null || next === void 0 ? void 0 : next.offset };
    }
    get hasTextures() {
        return !!this.vertex.texCoord;
    }
}
exports.NexusModel = NexusModel;
